



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { NotificationItem } from 'types/header';

@Component
export default class NotificationDropdownItem extends Vue {
	@Prop()
	notification!: NotificationItem;
}
